import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'Projects', href: '/projects' },
  { label: 'Community', href: '/community' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        transparent ? 'bg-transparent' : 'bg-white border-b border-gray-100'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/c84baff364ecb2a1782d953744be14df.png"
            alt="ALFA Decorators Logo"
            className="h-14 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.href;
            return (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); navigate(link.href); }}
                className={`px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer rounded-lg ${
                  active
                    ? transparent ? 'text-white bg-white/15' : 'text-[#2D2D2D] bg-[#F0F0F0]'
                    : transparent ? 'text-white/85 hover:text-white hover:bg-white/10' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                {link.label}
              </a>
            );
          })}
          <a
            href="/contact"
            onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
            className="ml-3 px-5 py-2.5 bg-[#2D2D2D] text-white text-sm font-semibold rounded-full whitespace-nowrap hover:bg-[#1a1a1a] transition-colors cursor-pointer"
          >
            Get a Free Quote
          </a>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-9 h-9 flex flex-col justify-center items-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block h-0.5 w-6 transition-all ${transparent ? 'bg-white' : 'bg-gray-800'}`} />
          <span className={`block h-0.5 w-6 transition-all ${transparent ? 'bg-white' : 'bg-gray-800'}`} />
          <span className={`block h-0.5 w-4 transition-all ${transparent ? 'bg-white' : 'bg-gray-800'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.href;
            return (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); navigate(link.href); setMenuOpen(false); }}
                className={`text-left font-medium py-2.5 px-3 rounded-lg transition-colors cursor-pointer text-sm ${
                  active ? 'text-[#2D2D2D] bg-[#F0F0F0]' : 'text-gray-700 hover:text-[#2D2D2D] hover:bg-gray-50'
                }`}
              >
                {link.label}
              </a>
            );
          })}
          <a
            href="/contact"
            onClick={(e) => { e.preventDefault(); navigate('/contact'); setMenuOpen(false); }}
            className="mt-3 px-5 py-3 bg-[#2D2D2D] text-white text-sm font-semibold rounded-full whitespace-nowrap hover:bg-[#1a1a1a] transition-colors cursor-pointer text-center"
          >
            Get a Free Quote
          </a>
        </div>
      )}
    </header>
  );
}
